var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRoundedLeftDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 9,
    viewBox: "0 0 8 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0533333 3.74939C0.0850625 3.66756 0.13264 3.5928 0.193334 3.52939L3.52667 0.196061C3.58883 0.133902 3.66262 0.084595 3.74383 0.0509548C3.82505 0.0173146 3.91209 0 4 0C4.17753 0 4.3478 0.0705253 4.47333 0.196061C4.53549 0.25822 4.5848 0.332014 4.61844 0.413228C4.65208 0.494443 4.66939 0.581488 4.66939 0.669394C4.66939 0.846929 4.59887 1.01719 4.47333 1.14273L2.27333 3.33606H7.33333C7.51014 3.33606 7.67971 3.4063 7.80474 3.53132C7.92976 3.65635 8 3.82592 8 4.00273C8 4.17954 7.92976 4.34911 7.80474 4.47413C7.67971 4.59916 7.51014 4.66939 7.33333 4.66939H2.27333L4.47333 6.86273C4.53582 6.9247 4.58541 6.99844 4.61926 7.07968C4.65311 7.16092 4.67053 7.24805 4.67053 7.33606C4.67053 7.42407 4.65311 7.51121 4.61926 7.59244C4.58541 7.67368 4.53582 7.74742 4.47333 7.80939C4.41136 7.87188 4.33762 7.92148 4.25638 7.95532C4.17514 7.98917 4.08801 8.00659 4 8.00659C3.91199 8.00659 3.82485 7.98917 3.74362 7.95532C3.66238 7.92148 3.58864 7.87188 3.52667 7.80939L0.193334 4.47606C0.13264 4.41266 0.0850625 4.3379 0.0533333 4.25606C-0.0133457 4.09375 -0.0133457 3.9117 0.0533333 3.74939Z",
    fill: "#28245C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRoundedLeftDark);
export default __webpack_public_path__ + "static/media/arrow-rounded-left-dark.7c992d7a633922a033edc6bb98095778.svg";
export { ForwardRef as ReactComponent };